<template>
  <div class="container">
    <div class="header">
      <!-- <div class="img"></div> -->
      <img class="img" src="../../assets/ffff4@2x.png" alt="">
      <p class="title">39元新人礼下载即送</p>
      <p class="title">邀请好友还可赢iPad</p>
    </div>
    <div class="body">
      <div class="invite_code">
        <p>好友邀请码：</p>
        <span>{{inviteCode}}</span>
        <button class="copy" :data-clipboard-text="inviteCode" @click="copy"><img src="../../assets/paste.png" alt=""></button>
      </div>
      <div class="btn" @click="submitFn">立即下载</div>
    </div>
  </div>
</template>

<script>
  import Clipboard from 'clipboard'
  import { Toast } from 'mint-ui';

  export default {
    name: "download",
    data() {
      return {
        inviteCode: ''
      }
    },
    created() {
      this.inviteCode = this.$route.query.code
      Toast({
        message: this.$route.query.code,
        position: 'bottom',
        duration: 3000
      })
    },
    methods: {
      copy() { 
        var clipboard = new Clipboard('.copy')
        clipboard.on('success', e => {
          console.log('复制成功')
          Toast({
            message: '复制成功',
            position: 'bottom',
            duration: 2000
          })
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
            // 不支持复制
            console.log('该浏览器不支持自动复制')
            // 释放内存
            clipboard.destroy()
        })
      },
      submitFn(){
        if(/MicroMessenger/gi.test(u)) {
          // 引导用户在浏览器中打开
            alert('请在浏览器中打开');
            return;
        }
        //判断浏览器
        var u = navigator.userAgent;
        var d = new Date();
        var t0 = d.getTime();
        if(u.indexOf('Android') > -1 || u.indexOf('Linux') > -1){
          //Android
          if(this.openApp('en://startapp')){
          this.openApp('en://startapp');
          }else{
            //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
            var delay = setInterval(function(){
                var d = new Date();
                var t1 = d.getTime();
                if( t1-t0<3000 && t1-t0>2000){
                    // alert('请下载APP');
                    Toast({
                      message: '请下载APP',
                      position: 'top',
                      duration: 2000
                    })
                    window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=hk.socap.tigercoach";
                }
                if(t1-t0>=3000){
                      clearInterval(delay);
                }
            },1000);
          }
        }else if(u.indexOf('iPhone') > -1){
          //IOS
          if(this.openApp('ios--scheme')){  
            this.openApp('ios--scheme');
          }else{
              var delay = setInterval(function(){
                  var d = new Date();
                  var t1 = d.getTime();
                  if( t1-t0<3000 && t1-t0>2000){
                    Toast({
                      message: '请下载APP',
                      position: 'top',
                      duration: 2000
                    })
                    window.location.href = "https://itunes.apple.com/cn/app/vue-%E8%A7%86%E9%A2%91%E7%BC%96%E8%BE%91%E4%B8%8E%E6%8B%8D%E6%91%84%E5%88%A9%E5%99%A8/id1114690993?mt=8&v0=WWW-GCCN-ITSTOP100-FREEAPPS&l=&ign-mpt=uo%3D4";
                  }
                  if(t1-t0>=3000){
                    clearInterval(delay);
                  }
              },1000);
          }
        }    
      },
      openApp(src) {
        // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
        // 否则打开a标签的href链接
        var ifr = document.createElement('iframe');
        ifr.src = src;
        ifr.style.display = 'none';
        document.body.appendChild(ifr);
        window.setTimeout(function(){
              document.body.removeChild(ifr);
        },2000);
      }
    }
  }
</script>

<style lang="less" scoped>
  .container {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    .header {
      width: 100%;
      height: 70%;
      color: #fff;
      overflow: hidden;
      background:linear-gradient(0deg,rgba(109,164,248,1) 0%,rgba(163,170,237,1) 19%,rgba(109,164,248,1) 37%,rgba(169,171,237,1) 56.00000000000001%,rgba(116,165,247,1) 75%,rgba(161,169,237,1) 100%);
      display: flex;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      .img {
        width: 2.86rem;
        height: 2.58rem;
        margin: 0.28rem 0 0.37rem;
      }
      .title {
        width: 100%;
        height: 0.36rem;
        line-height: 0.36rem;
        text-align: center;
        font-size: 0.20rem;
        font-weight: 600;
      }
    }
    .body {
      width: 100%;
      height: 30%;
      background-color: #fff;
      overflow: hidden;
      .invite_code {
        height: 0.5rem;
        text-align: center;
        margin-top: 0.25rem;
        p {
          width: 100%;
          color: #000;
          font-size: 0.15rem;
          font-weight: 600;
        }
        span {
          color: #E3721E;
          font-size: 0.25rem;
          font-weight: 600;
        }
        img {
          width: 0.10rem;
          height: 0.15rem;
        }
      }
      .btn {
        width: 80%;
        margin: 0.27rem auto 0;
        height: 0.35rem;
        line-height: 0.35rem;
        text-align: center;
        background: #5167AA;
        border-radius: 0.1rem;
        font-size: 0.17rem;
        font-weight: 600;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/views/appdownload/index.vue